<template>
    <section id="section">
        <div v-show="!isLoading && info.title" class="info-box">
            <div v-if="msgShow && tmp_key" class="df ac jcsb global-msg">
                <div>此为临时链接，仅用于预览，将在短期内失效。</div>
                <i class="df jcc ac cp icon-close" @click="msgShow = false"></i>
            </div>
            <h3 class="title">{{info.title}}</h3>
            <div class="tip">发布时间 {{$date(info.addtime)}} <span class="view">阅读 {{info.views}}</span></div>
            <img class="img" :src="info.thumb" alt="">
            <div v-html="info.content"></div>
        </div>
        <base-not-found v-if="!isLoading && !info.title"></base-not-found>
    </section>
</template>

<script>
    export default {
        data: () => ({
            isLoading: true,
            msgShow: true,
            info: {
                title: '',
                content: '',
                thumb: '',
                addtime: '',
                views: 0,
            },
        }),
        computed: {
            video() {
                return this.$store.state.video;
            },
            tmp_key() {
                return this.$route.query.tmp_key || '';
            }
        },
        beforeCreate() {
            let vd = document.getElementById('info-css'), style = `
.info-box img {
    max-width: 100%;
}

@media screen and (min-width: 1024px) {
    .info-box video {
        width: 677px;
        height: 381px;
    }
}
`;
            if (vd) {
                vd.innerHTML = style;
            } else {
                vd = document.createElement('style');
                vd.id = 'info-css';
                vd.innerHTML = style;
                document.head.appendChild(vd);
            }
        },
        async beforeMount() {
            const e = await this.api.get(`info/${this.$route.params.id}`, {tmp_key: this.tmp_key}).catch(this.err);
            if (!e) return this.isLoading = false;

            this.info = e;
            this.isLoading = false;
            this.$nextTick(() => {
                let videos = document.getElementsByTagName('video'), vm = this, l = videos.length;
                while(l--) {
                    videos[l].className = 'video-js vjs-default-skin vjs-big-play-centered';
                    videos[l].oncontextmenu = e => e.preventDefault();
                    vm.$video(videos[l], {
                        playbackRates: [0.1, 0.2, 0.5, 1.0], //播放速度
                        autoplay: false,
                        muted: false,
                        loop: false,
                        preload: 'auto',
                        language: 'zh-CN',
                        aspectRatio: '16:9',
                        fluid: true,
                        sources: [{
                            type: 'video/mp4',
                            src: videos[l].src //url地址
                        }],
                        poster: videos[l].getAttribute('poster'),
                        notSupportedMessage: '此视频暂无法播放，请稍后再试',
                        controlBar: {
                            remainingTimeDisplay: false,
                            volumePanel: {
                                inline: false
                            }
                        },
                        errorDisplay: false,
                        posterImage: false,
                        bigPlayButton: true,
                        textTrackDisplay: false,
                    }, function () {
                        this.tech_.off('dblclick');
                        this.on('play', () => {
                            this.volume(vm.video.volume);
                        });

                        this.on('volumechange', () => {
                            vm.video.volume = this.volume();
                            window.localStorage.volume = this.volume();
                        });

                        this.on('error', () => {
                            let err = this.error();
                            if (err.code === 2) {// 判断是否是网络加载问题
                                let buffTime = this.bufferedEnd() - 6;
                                this.load(vm.src);
                                this.currentTime(buffTime);
                                this.play();
                            } else {
                                vm.alert.err(err.message);
                            }
                        })
                    });
                }
            });
        },
        beforeDestroy() {
            document.getElementById('info-css').innerHTML = '';
        },
    }
</script>

<style>
    @import "../../../static/css/components/video-js-me.css";
</style>

<style scoped>
    @import "../../../static/css/common/tab.css";
    @import "../../../static/css/views/info/index.css";
</style>


// WEBPACK FOOTER //
// src/views/info/index.vue